import React from 'react'
import { Link as GatsbyLink } from 'gatsby'
import { Typography } from '@leshen/gatsby-theme-leshen'

/**
 * @param {string} key
 * @param {string} state
 * @param {string} city
 * @returns {{question: string, answer: string}}
 */
export function getCityFAQ(key, state, city) {
  const faq = {
    QA1: {
      question: `Is DISH Network offered in ${city}, ${state}?`,
      answer: (
        <Typography variant="feature">
          DISH Network is offered in {city}, {state} as well as the other 49
          states in the U.S. Call to see if it’s available in your
          neighborhood.
        </Typography>
      ),
    },
    QA2: {
      question: `Does ${city}, ${state} offer DISH Satellite TV services? `,
      answer: (
        <Typography variant="feature">
          {city}, {state} offers DISH satellite TV services, including sports
          packages and local programming. Find out if DISH satellite TV is in
          your area today.
        </Typography>
      ),
    },
    QA3: {
      question: `Is DISH TV available near ${city}, ${state}?`,
      answer: (
        <Typography variant="feature">
          DISH TV is available in {city}, {state}. From sports packages to
          local programming, DISH TV offers multiple entertainment options.
          Find out if DISH TV is offered at your address today.
        </Typography>
      ),
    },
    QA4: {
      question: `Is DISH Network available in ${city}, ${state}?`,
      answer: (
        <Typography variant="feature">
          DISH Network is available in {city}, {state}. Find out if DISH
          Network is available at your address by giving us a call.
        </Typography>
      ),
    },
    QP1: {
      question: `What is the cost of DISH Satellite TV in ${city}, ${state}?`,
      answer: (
        <Typography variant="feature">
          DISH Satellite TV costs vary by package size. In {city}, {state},
          packages start at $91.99/mo.for the basic America’s Top 120 package.
          Give us a call to learn more about package prices.
        </Typography>
      ),
    },
    QP2: {
      question: `How much are DISH Network packages in ${city}, ${state}?`,
      answer: (
        <Typography variant="feature">
          DISH Network packages in {city}, {state} start at $91.99/mo. for the
          basic America’s Top 120 package. Call to learn more about the
          additional TV packages DISH offers.
        </Typography>
      ),
    },
    QP3: {
      question: `How much does satelllite tv service cost in ${city}, ${state}?`,
      answer: (
        <Typography variant="feature">
          Satellite TV service from DISH starts at $91.99/mo. in {city},
          {state}. Prices vary depending on add-ons like the sports package or
          the DISH Movie Pack. Call for more details.
        </Typography>
      ),
    },
    QP4: {
      question: `What is the price of satellite TV in ${city}, ${state}?`,
      answer: (
        <Typography variant="feature">
          DISH satellite TV prices in {city}, {state} start at $91.99/mo.
          depending on the package you choose. Call to find out what packages
          are available in your area.
        </Typography>
      ),
    },
    QC1: {
      question: `What is the number to contact DISH Network in ${city}, ${state}?`,
      answer: (
        <Typography variant="feature">
          The number to contact DISH Network in {city}, {state} is{' '}
          <a href={'tel:833-871-4427'}>833-871-4427</a>.
        </Typography>
      ),
    },
    QC2: {
      question: `What is the phone number to get DISH TV service in ${city}, ${state}`,
      answer: (
        <Typography variant="feature">
          The phone number to get DISH TV service in {city}, {state} is{' '}
          <a href={'tel:833-871-4427'}>833-871-4427</a>.
        </Typography>
      ),
    },
    QC3: {
      question: `How can I contact DISH satellite TV in ${city}, ${state}?`,
      answer: (
        <Typography variant="feature">
          You can contact DISH satellite TV by calling{' '}
          <a href={'tel:833-871-4427'}>833-871-4427</a>.
        </Typography>
      ),
    },
    QC4: {
      question: `How do I contact DISH Network in ${city}, ${state}?`,
      answer: (
        <Typography variant="feature">
          Call <a href={'tel:833-871-4427'}>833-871-4427</a> to contact DISH
          Network in {city}, {state}.
        </Typography>
      ),
    },
    QB1: {
      question: `How much do DISH TV and internet packages in ${city}, ${state} cost?`,
      answer: (
        <Typography variant="feature">
          DISH TV and internet packages in {city}, {state} vary in pricing.
          Your monthly bill will vary depending on which internet provider you
          go with and the TV package that works for you. Call and find out how
          much it would cost to{' '}
          <GatsbyLink to="https://www.usdish.com/bundles">
            bundle your internet and TV
          </GatsbyLink>{' '}
          today!
        </Typography>
      ),
    },
    QB2: {
      question: `Does DISH Satellite TV offer bundles with internet in ${city}, ${state}?`,
      answer: (
        <Typography variant="feature">
          DISH Satellite TV offers bundles with internet in {city}, {state}.
          Depending on where you live, it can be satellite internet with
          HughesNet or fiber internet with Frontier. Either way, you can have
          the best of both worlds when you{' '}
          <GatsbyLink to="https://www.usdish.com/bundles">
            bundle DISH TV with internet
          </GatsbyLink>
          .
        </Typography>
      ),
    },
    QB3: {
      question: `Can I bundle internet with DISH TV in ${city}, ${state}?`,
      answer: (
        <Typography variant="feature">
          You can{' '}
          <GatsbyLink to="https://www.usdish.com/bundles">
            bundle internet with DISH TV
          </GatsbyLink>{' '}
          in {city}, {state}. Call to find out which internet providers are in
          your area and which TV package works best for you.
        </Typography>
      ),
    },
    QB4: {
      question: `Can I combine internet services with DISH TV in ${city}, ${state}?`,
      answer: (
        <Typography variant="feature">
          Yes, you can indeed{' '}
          <GatsbyLink to="https://www.usdish.com/bundles">
            bundle internet services with DISH TV
          </GatsbyLink>{' '}
          in your state, depending on the availability of internet providers
          partnered with DISH. These partners often include HughesNet
          Satellite Internet and Frontier, providing high-speed internet
          access across various regions.
        </Typography>
      ),
    },
    QD1: {
      question: `What type of satellite TV packages are offered in ${city}, ${state}?`,
      answer: (
        <Typography variant="feature">
          DISH offers three satellite TV packages in {city}, {state}:
          America&#39;s Top 120-190 channels, including 60+ in high definition;
          America&#39;s Top 200-240+ channels, including 125+ in high definition;
          America&#39;s Top 250-290+ channels, including 140+ in high definition.
        </Typography>
      ),
    },
    QD2: {
      question: `What type of deals does DISH TV offer near ${city}, ${state}?`,
      answer: (
        <Typography variant="feature">
          DISH TV offers tons of deals near {city}, {state}, including a
          2-year TV price guarantee, free standard professional installation,
          and free premium channels for three months, just to name a few.
        </Typography>
      ),
    },
    QD3: {
      question: `What deals are available for DISH in ${city}, ${state}?`,
      answer: (
        <Typography variant="feature">
          A 2-year price guarantee, free standard professional installation,
          and a free DISH Anywhere mobile app are just a few of the deals
          available with DISH in {city}, {state}. Call to learn more about all
          the deals DISH has to offer.
        </Typography>
      ),
    },
    QD4: {
      question: `Does DISH Network offer any deals in ${city}, ${state}?`,
      answer: (
        <Typography variant="feature">
          DISH Network offers a 2-year price guarantee, free premium channels
          for three months, and free HD for life in {city}, {state}, just to
          name a few. Call us to learn more about DISH deals in your area.
        </Typography>
      ),
    },
    QI1: {
      question: `Is DISH internet available in ${city}, ${state}?`,
      answer: (
        <Typography variant="feature">
          DISH Network works with internet providers such as HughesNet and
          Frontier to connect you to the internet in {city}, {state}. Call us
          to find out if DISH offers{' '}
          <GatsbyLink to="https://www.usdish.com/bundles">
            internet bundles in your area
          </GatsbyLink>
          .
        </Typography>
      ),
    },
    QI2: {
      question: `Does DISH Network offer internet in ${city}, ${state}?`,
      answer: (
        <Typography variant="feature">
          Satellite TV service from DISH starts at $91.99/mo. in {city},
          {state}. Prices vary depending on add-ons like the sports package or
          the DISH Movie Pack. Call for more details.
        </Typography>
      ),
    },
    QI3: {
      question: `Can I get internet with DISH in ${city}, ${state}?`,
      answer: (
        <Typography variant="feature">
          You can get internet with one of DISH’s internet partners in {city},{' '}
          {state}. Find out if DISH has internet partners serving your address
          by giving us a call.
        </Typography>
      ),
    },
    QI4: {
      question: `Does DISH have satellite internet in ${city}, ${state}?`,
      answer: (
        <Typography variant="feature">
          DISH works with Hughesnet to provide satellite internet in rural
          areas. DISH also works with Frontier to connect customers to the
          internet through a fiber network. Find out which internet provider
          services your area by giving us a call.
        </Typography>
      ),
    },
  }

  return faq[key]
}

/**
 * @param {string} key
 * @param {string} state
 * @param {string} city
 * @returns {{question: string, answer: string}}
 */
export function getCityFAQSchema(key, state, city) {
  const schemaFAQ = {
    QA1: {
      question: `Is DISH Network offered in ${city}, ${state}?`,
      answer: `DISH Network is offered in ${city}, ${state} as well as the other 49
      states in the U.S. Call to see if it’s available in your
      neighborhood.`,
    },
    QA2: {
      question: `Does ${city}, ${state} offer DISH Satellite TV services?`,
      answer: `${city}, ${state} offers DISH satellite TV services, including
      sports packages and local programming. Find out if DISH satellite TV
      is in your area today.`,
    },
    QA3: {
      question: `Is Dish TV available near ${city}, ${state}?`,
      answer: `DISH TV is available in ${city}, ${state}. From sports packages to
      local programming, DISH TV offers multiple entertainment options.
      Find out if DISH TV is offered at your address today.`,
    },
    QA4: {
      question: `Is DISH Network availabile in ${city}, ${state}?`,
      answer: `DISH Network is available in ${city}, ${state}. Find out if DISH Network is available at your address by giving us a call.`,
    },
    QP1: {
      question: `What is the cost of DISH Satellite TV in ${city}, ${state}?`,
      answer: `DISH Satellite TV costs vary by package size. In ${city}, ${state},
      packages start at $91.99/mo.for the basic America’s Top 120 package.
      Give us a call to learn more about package prices.`,
    },
    QP2: {
      question: `How much are DISH Network packages in ${city}, ${state}?`,
      answer: `DISH Network packages in ${city}, ${state} start at $91.99/mo. for the
      basic America’s Top 120 package. Call to learn more about the
      additional TV packages DISH offers.`,
    },
    QP3: {
      question: `How much does satelllite TV service cost in ${city}, ${state}?`,
      answer: `Satellite TV service from DISH starts at $91.99/mo. in ${city}, ${state}. Prices vary depending on add-ons like the sports package or
      the DISH Movie Pack. Call for more details.`,
    },
    QP4: {
      question: `What is the price of satellite TV in ${city}, ${state}?`,
      answer: `DISH satellite TV prices in ${city}, ${state} start at $91.99/mo.
      depending on the package you choose. Call to find out what packages
      are available in your area.`,
    },
    QC1: {
      question: `What is the number to contact DISH Network in ${city}, ${state}?`,
      answer: `The number to contact DISH Network in ${city}, ${state} is <a href={'tel:833-871-4427'}>833-871-4427</a>`,
    },
    QC2: {
      question: `What is the phone number to get DISH TV service in ${city}, ${state}?`,
      answer: `The phone number to get DISH TV service in ${city}, ${state} is <a href={'tel:833-871-4427'}>833-871-4427</a>.`,
    },
    QC3: {
      question: `How can I contact DISH TV satellite TV in ${city}, ${state}?`,
      answer: 'You can contact DISH satellite TV by calling <a href={\'tel:833-871-4427\'}>833-871-4427</a>.',
    },
    QC4: {
      question: `How do I contact DISH Network in ${city}, ${state}?`,
      answer: `Call <a href={'tel:833-871-4427'}>833-871-4427</a> to contact
      DISH Network in ${city}, ${state}.`,
    },
    QB1: {
      question: `How much do DISH TV and internet packages in ${city}, ${state} cost?`,
      answer: `DISH TV and internet packages in ${city}, ${state} vary in pricing. Your monthly bill will vary depending on which internet provider you go with and the TV package that works for you. Call and find out how much it would be to <a href='https://www.usdish.com/bundles'>bundle your internet and TV</a> today!`,
    },
    QB2: {
      question: `Does DISH Satellite TV offer bundles with internet in ${city}, ${state}?`,
      answer: `DISH satellite TV offers bundles with internet in ${city}, ${state}. Depending on where you live, it can be satellite internet with Hughesnet or fiber internet with Frontier. Either way, you can have the best of both worlds when you bundle DISH TV with internet.`,
    },
    QB3: {
      question: `Can I bundle internet with DISH TV in ${city}, ${state}?`,
      answer: `You can bundle internet with DISH TV in ${city}, ${state}. Call to find out which internet providers are in your area and which TV package works best for you.`,
    },
    QB4: {
      question: `Can I combine internet services with DISH TV in ${city}, ${state}?`,
      answer: 'Yes, you can indeed bundle internet services with DISH TV in your state, depending on the availability of internet providers partnered with DISH. These partners often include HughesNet Satellite Internet and Frontier, providing high-speed internet access across various regions.',
    },
    QD1: {
      question: `What type of satellite TV packages are offered in ${city}, ${state}?`,
      answer: `DISH offers four satellite TV packages in ${city}, ${state}: America's Top 120 - 190 channels, including 60+ in high definition; America's Top 200 - 240+ channels, including 125+ in high definition; America's Top 250 - 290+ channels, including 140+ in high definition`,
    },
    QD2: {
      question: `What type of deals does DISH TV offer near ${city}, ${state}?`,
      answer: `DISH TV offers tons of deals near ${city}, ${state}, including a 2-year TV price guarantee, free standard professional installation, and free premium channels for three months, just to name a few.`,
    },
    QD3: {
      question: `What deals are available for DISH in ${city}, ${state}?`,
      answer: `A 2-year price guarantee, free standard professional installation, and a free DISH Anywhere mobile app are just a few of the deals available with DISH in ${city}, ${state}. Call to learn more about all the deals DISH has to offer.`,
    },
    QD4: {
      question: `Does DISH Network offer any deals in ${city}, ${state}?`,
      answer: `DISH Network offers a 2-year price guarantee, free premium channels for three months, and free HD for life in ${city}, ${state}, just to name a few. Call us to learn more about DISH deals in your area.`,
    },
    QI1: {
      question: `Is DISH internet available in ${city}, ${state}?`,
      answer: `DISH Network works with internet providers such as Hughesnet and Frontier to connect you to the internet in ${city}, ${state}. Call us and find out if DISH offers internet bundles in your area.`,
    },
    QI2: {
      question: `Does DISH Network offer internet in ${city}, ${state}?`,
      answer: `Satellite TV service from DISH starts at $91.99/mo. in ${city}, ${state}. Prices vary depending on add-ons like the sports package or the DISH Movie Pack. Call for more details.`,
    },
    QI3: {
      question: `Does DISH Network offer internet in ${city}, ${state}?`,
      answer: `You can get internet with one of DISH’s internet partners in ${city}, ${state}. Find out if DISH has internet partners serving your address by giving us a call.`,
    },
    QI4: {
      question: `Does DISH have satellite internet in ${city}, ${state}?`,
      answer: 'DISH works with Hughesnet to provide satellite internet in rural areas. DISH also works with Frontier to connect customers to the internet through a fiber network. Find out which internet provider services your area by giving us a call.',
    },
  }
  return schemaFAQ?.[key]
}
